import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdditionalDeputateForm } from '../forms/AdditionalDeputateForm';

type AdditionalDeputateModalProps = {
  deputatUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const AdditionalDeputateModal = ({ deputatUuid, isOpen, onClose }: AdditionalDeputateModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  return (
    <Modal
      title={deputatUuid ? t('deputate.edit') : t('deputate.add')}
      isOpen={isOpen}
      onRequestClose={onClose}
      loading={loading}
    >
      <AdditionalDeputateForm deputatUuid={deputatUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
